import React from 'react';
import { Link } from 'react-router-dom';

const RentOutModal = ({ isOpen, closeModal, itemData }) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h4>Rent Out Information</h4>
                <p><strong>Item Code:</strong> {itemData?.itemCode}</p>
                <Link to={`/order/${itemData?._id}`}>

                    <p><strong>Order :</strong> {itemData?.orderId}</p>
                </Link>
                <button onClick={closeModal}>Close</button>
            </div>
        </div>
    );
};

export default RentOutModal;
